export const imagesMetadata = {
    // -----  CARPENTRY  -----
    "/static/images/carpentry/burwood-east-load-bearing-wall-removal-01.webp": {
        "caption": "Carpentry",
        "location": "Burwood East",
        "alt": "Load bearing wall removed to open up space in Burwood East home by Handyman In Melbourne."
    },

    "/static/images/carpentry/carrum-downs-pergola-timber-beam-replacement-01.webp": {
        "caption": "Carpentry",
        "location": "Carrum Downs",
        "alt": "Rotten timber beam replacement for an outdoor pergola in Carrum Downs by Handyman In Melbourne."
    },

    "/static/images/carpentry/doncaster-storage-cabinet-installation-01.webp": {
        "caption": "Carpentry",
        "location": "Doncaster",
        "alt": "Professional storage cabinet installation in Doncaster using a green laser level for precise alignment by Handyman In Melbourne."
    },

    "/static/images/carpentry/glen-iris-timber-deck-stair-construction-01.webp": {
        "caption": "Carpentry",
        "location": "Glen Iris",
        "alt": "Carpentry service showing a modern timber deck staircase upgrade over original brick steps in Glen Iris by Handyman In Melbourne."
    },

    "/static/images/carpentry/moonee-ponds-laundry-cupboard-shelving-01.webp": {
        "caption": "Carpentry",
        "location": "Moonee Ponds",
        "alt": "Custom laundry cupboard shelving installation in Moonee Ponds by Handyman In Melbourne."
    },

    "/static/images/carpentry/moonee-ponds-laundry-cupboard-shelving-02.webp": {
        "caption": "Carpentry",
        "location": "Moonee Ponds",
        "alt": "Custom laundry cupboard shelving installation in Moonee Ponds by Handyman In Melbourne."
    },

    "/static/images/carpentry/rowville-cupboard-shelving-installation-01.webp": {
        "caption": "Carpentry",
        "location": "Rowville",
        "alt": "Custom Closer cupboard shelving installation in Rowville by Handyman In Melbourne."
    },


    // -----  FURNITURE ASSEMBLY  -----
    "/static/images/furniture-assembly/beaumaris-outdoor-furniture-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Beaumaris",
        "alt": "Outdoor furniture assembly and setup in Beaumaris by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/cheltenham-ikea-pax-wardrobe-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Cheltenham",
        "alt": "House renovation upgrading the built-in wardrobe with IKEA PAX and sliding door in Cheltenham by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/clayton-ikea-drawer-and-makeup-dresser-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Clayton",
        "alt": "Makeup desk designed and assembled using IKEA drawer units and shelves in Clayton by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/dingley-village-walk-in-robe-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Dingley Village",
        "alt": "WIR upgrade from the old shelf to modern IKEA wardrobe system in Dingley Village by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/dingley-village-walk-in-robe-rod-installation-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Dingley Village",
        "alt": "Before and After. Walk-in-robe design, assembly, and custom installation in Dingley Village by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/hawthorn-cabinet-installation-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Hawthorn",
        "alt": "Laundry storage cabinet assembly and installation and setup in Hawthorn by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/mount-waverley-gas-lift-bed-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Mount Waverley",
        "alt": "Single gas lifting bed flatpack assembly in Mount Waverley by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/mount-waverley-gas-lift-bed-assembly-02.webp": {
        "caption": "Furniture Assembly",
        "location": "BeaumMount Waverleyaris",
        "alt": "King size gas lifting bed and desk flatpack assembly in Mount Waverley by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/pascoe-vale-ikea-pax-wardrobe-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Pascoe Vale",
        "alt": "Upgrading the bedroom storage with IKEA PAX wardrobe assembly and installation in Pascoe Vale by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/point-cook-bunk-bed-and-desk-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Point Cook",
        "alt": "Bunk bed flatpack assembly and desk room setup in Point Cook by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/sandringham-ikea-pax-wardrobe-installation-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Sandringham",
        "alt": "Professional flatpack wardrobe assembly and installation in Sandringham by Handyman In Melbourne."
    },

    "/static/images/furniture-assembly/waterways-chest-of-drawers-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Waterways",
        "alt": "Chest of 6 drawers flatpack assembly in Waterways by Handyman In Melbourne."
    },


    // -----  GARDENING  -----



    // ----- HOME MAINTENANCE  -----
    "/static/images/home-maintenance/middle-park-wall flashing-downpipe-installation-01.webp": {
        "caption": "Downpipe Replacement",
        "location": "Middle Park",
        "alt": "Before and After. Replacing rusted downpipe caused by incorrect raise/angle, set to correct fall for drainage in Middle Park by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/middle-park-wall flashing-downpipe-installation-02.webp": {
        "caption": "Flashing Installation",
        "location": "Middle Park",
        "alt": "Before and After. Installing flashing/capping for double brick wall to prevent water damage in Middle Park by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/glen-iris-double-brick-wall-patch-painting-01.webp": {
        "caption": "Wall Repair",
        "location": "Glen Iris",
        "alt": "Before and After. Double brick house cracked and falling mortar repair and painting in Glen Iris by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/clayton-rubbish-removal-01.webp": {
        "caption": "Home Maintenance",
        "location": "Clayton",
        "alt": "Rubbish removal and disposal for home in Clayton by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/doncaster-laundry-splashback-tiling-01.webp": {
        "caption": "Home Maintenance",
        "location": "Doncaster",
        "alt": "Splashback installation after laundry renovation apartment in Doncaster by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/moorabbin-gutter-replacement-01.webp": {
        "caption": "Home Maintenance",
        "location": "Moorabbin",
        "alt": "Gutter replacement due to rust, silicone around the joints to provent leak in Moorabbin by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/moorabbin-high-pressure-washing-01.webp": {
        "caption": "Home Maintenance",
        "location": "Moorabbin",
        "alt": "External high pressure cleanning before open house inspection in Moorabbin by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/rowville-bath-tile-installation-01.webp": {
        "caption": "Home Maintenance",
        "location": "Rowville",
        "alt": "Prepping and sealing the surrounding hob structure to guarantee a 100% watertight seal before laying any tile in Rowville by Handyman In Melbourne."
    },
    
    "/static/images/home-maintenance/rowville-bath-tile-installation-02.webp": {
        "caption": "Home Maintenance",
        "location": "Rowville",
        "alt": "Cutting and laying matching marble-look tiles to sit perfectly level and flush against the bath edge in Rowville by Handyman In Melbourne."
    },

    "/static/images/home-maintenance/wheelers-hill-outdoor-tap-replacement-01.webp": {
        "caption": "Home Maintenance",
        "location": "Wheelers Hill",
        "alt": "Rustted outdoor tap replacement with leak inspection in Wheelers Hill by Handyman In Melbourne."
    },

    // ----- COMMERCIAL MAINTENANCE  -----

    "/static/images/commercial-maintenance/southbank-office-white-board-installation-01.webp": {
        "caption": "Whiteboard Installation",
        "location": "Southbank",
        "alt": "Professional whiteboard installation for an office in Southbank by Handyman In Melbourne."
    },

    "/static/images/commercial-maintenance/dandenong-south-commercial-wall-repair-01.webp": {
        "caption": "Commercial Maintenance",
        "location": "Dandenong South",
        "alt": "Before and after comparison of a commercial warehouse wall repair and window installation in Dandenong South, showing an open doorway framed in and fitted with a clean glass window panel by Handyman In Melbourne."
    },

    "/static/images/commercial-maintenance/dandenong-south-concrete-repair-01.webp": {
        "caption": "Commercial Maintenance",
        "location": "Dandenong South",
        "alt": "Concrete repair and patching for warehouse in Dandenong South by Handyman In Melbourne."
    },

    "/static/images/commercial-maintenance/cheltenham-pop-up-store-setup-01.webp": {
        "caption": "PopUp Store",
        "location": "Westfield Southland",
        "alt": "New Pop Up Store Setup in the Southland Shopping Centre by Handyman In Melbourne."
    },

    "/static/images/commercial-maintenance/burwood-office-furniture-assembly-01.webp": {
        "caption": "Furniture Assembly",
        "location": "Burwood",
        "alt": "Office furniture assembly in Burwood by Handyman In Melbourne."
    },

    "/static/images/commercial-maintenance/melbourne-cbd-meeting-room-tv-installation-01.webp": {
        "caption": "TV Mounting",
        "location": "Melbourne CBD",
        "alt": "TV ans stand setup for meeting room with nest bar in Melbourne CBD by Handyman In Melbourne."
    },

    "/static/images/commercial-maintenance/melbourne-cbd-meeting-room-tv-installation-02.webp": {
        "caption": "TV Mounting",
        "location": "Melbourne CBD",
        "alt": "TV ans stand setup for meeting room in Melbourne CBD by Handyman In Melbourne."
    },

    // -----  INSTALLATIONS  -----
    "/static/images/installations/blackburn-bathroom-mirror-installation-01.webp": {
        "caption": "Mirror Installation",
        "location": "Blackburn",
        "alt": "Modern bathroom vanity upgrade featuring a circular mirror installation in Blackburn by Handyman In Melbourne."
    },

    "/static/images/installations/burwood-bathroom-mirror-installation-01.webp": {
        "caption": "Mirror Installation",
        "location": "Burwood",
        "alt": "Professional arched bathroom mirror installation over a vanity in Burwood clean hole drilled into tiles by Handyman In Melbourne."
    },

    "/static/images/installations/burwood-bathroom-mirror-installation-02.webp": {
        "caption": "Mirror Installation",
        "location": "Burwood",
        "alt": "Double arched mirror installation above a dual vanity in a Burwood bathroom by Handyman In Melbourne."
    },

    "/static/images/installations/burwood-bathroom-mirror-installation-03.webp": {
        "caption": "Mirror Installation",
        "location": "Burwood",
        "alt": "Professional mirror mounting and bathroom hardware installation in Burwood by Handyman In Melbourne."
    },

    "/static/images/installations/doncaster-bathroom-mirror-and-shower-screen-installation-01.webp": {
        "caption": "Mirror Installation",
        "location": "Doncaster",
        "alt": "Professional bathroom mirror and frameless shower screen installation in Doncaster by Handyman In Melbourne."
    },
    
    "/static/images/installations/rowville-bathroom-grab-rail-installation-01.webp": {
        "caption": "Installation",
        "location": "Rowville",
        "alt": "Stainless steel grab rail installation for improved bathroom safety in Rowville by Handyman In Melbourne."
    },

    "/static/images/installations/vermont-freestanding-mailbox-installation-01.webp": {
        "caption": "Mailbox Installation",
        "location": "Vermont",
        "alt": "Modern freestanding mailbox installation in Vermont by Handyman In Melbourne."
    },


    // -----  PLASTERING PAINTING  -----
    "/static/images/plastering-painting/chadstone-deck-fence-painting-01.webp": {
        "caption": "Painting",
        "location": "Chadstone",
        "alt": "Complete timber deck and pailing fence painted for a mordern look, UV protection in Chadstone by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/chadstone-deck-fence-painting-03.webp": {
        "caption": "Painting",
        "location": "Chadstone",
        "alt": "Complete timber deck and pailing fence painted for a mordern look, UV protection in Chadstone by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/berwick-ceiling-crack-patching-01.webp": {
        "caption": "Patching",
        "location": "Berwick",
        "alt": "Before and After. Ceiling crack repair and hole patching service in Berwick by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/berwick-garage-ceiling-plastering-01.webp": {
        "caption": "Patching",
        "location": "Berwick",
        "alt": "Before and After. New plasterboard ceiling installation and finishing in a residential garage in Berwick by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/berwick-garage-ceiling-plastering-02.webp": {
        "caption": "Patching",
        "location": "Berwick",
        "alt": "Professional ceiling plastering and installation service in Berwick by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/berwick-garage-ceiling-plastering-03.webp": {
        "caption": "Patching",
        "location": "Berwick",
        "alt": "Professional ceiling plastering, installation and painting service in Berwick by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/blackburn-timber-gate-sanding-01.webp": {
        "caption": "Painting",
        "location": "Blackburn",
        "alt": " by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/camberwell-timber-fence-painting-01.webp": {
        "caption": "Painting",
        "location": "Camberwell",
        "alt": "Exterior timber fence painting and restoration service in Camberwell by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/clayton-drywall-wall-patching-01.webp": {
        "caption": "Patching",
        "location": "Clayton",
        "alt": "Drywall patching and hole repair above a wall-mounted shelf in a Clayton home by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/clayton-timber-deck-painting-01.webp": {
        "caption": "Painting",
        "location": "Clayton",
        "alt": "Timber deck high pressure cleaning and protective painting in Clayton by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/doncaster-interior-painting-preparation-01.webp": {
        "caption": "Painting",
        "location": "Doncaster",
        "alt": "Interior painting preparation including masking tape and floor protection in Doncaster by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/doncaster-interior-wall-painting-01.webp": {
        "caption": "Painting",
        "location": "Doncaster",
        "alt": "Interior wall painting and home renovation service in Doncaster by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/heidelberg-commercial-exterior-painting-01.webp": {
        "caption": "Painting",
        "location": "Heidelberg",
        "alt": "Commercial warehouse exterior painting and maintenance in Heidelberg by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/moorabbin-timber-deck-painting-01.webp": {
        "caption": "Painting",
        "location": "Moorabbin",
        "alt": "Professional timber deck painting and staining service in Moorabbin by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/richmond-wall-hole-patching-01.webp": {
        "caption": "Patching",
        "location": "Richmond",
        "alt": "Professional wall patching and plaster repair service in Richmond by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/st-kilda-interior-hallway-painting-01.webp": {
        "caption": "Painting",
        "location": "St Kilda",
        "alt": "Expert interior painter in St Kilda showcasing a finished hallway and console entryway display by Handyman In Melbourne."
    },

    "/static/images/plastering-painting/st-kilda-interior-hallway-painting-02.webp": {
        "caption": "Painting",
        "location": "St Kilda",
        "alt": "Interior painting project showcasing a dark green hallway renovation in a St Kilda home by Handyman In Melbourne."
    },


    // -----  TV MOUNTING WALL ART  -----
    "/static/images/tv-mounting-wall-art/bentleigh-tv-wall-mounting-with-concealed-cables-01.webp": {
        "caption": "TV Mounting",
        "location": "Bentleigh",
        "alt": "Neat cable management and concealment for TV mounting in Bentleigh by Handyman In Melbourne."
    },

    "/static/images/tv-mounting-wall-art/bentleigh-tv-wall-mounting-with-concealed-cables-02.webp": {
        "caption": "TV Mounting",
        "location": "Bentleigh",
        "alt": "Secure TV mounting with concealed cables in Bentleigh by Handyman In Melbourne."
    },

    "/static/images/tv-mounting-wall-art/brighton-picture-hanging-01.webp": {
        "caption": "Picture Hanging",
        "location": "Brighton",
        "alt": "Kids artwork display picture hanging in Brighton by Handyman In Melbourne."
    },

    "/static/images/tv-mounting-wall-art/brighton-picture-hanging-02.webp": {
        "caption": "Picture Hanging",
        "location": "Brighton",
        "alt": "Artwork hanging on plasterboard wall in Brighton by Handyman In Melbourne."
    },

    "/static/images/tv-mounting-wall-art/glen-waverley-fireplace-tv-wall-mounting-01.webp": {
        "caption": "TV Mounting",
        "location": "Glen Waverley",
        "alt": "Supply and install full motion pull down TV bracket to fit above fireplace in Glen Waverley by Handyman In Melbourne."
    },

    "/static/images/tv-mounting-wall-art/mentone-picture-hanging-01.webp": {
        "caption": "Picture Hanging",
        "location": "Menton",
        "alt": "Professional picture gallery on double brick house in Menton by Handyman In Melbourne."
    },

    "/static/images/tv-mounting-wall-art/mentone-picture-hanging-02.webp": {
        "caption": "Picture Hanging",
        "location": "Menton",
        "alt": "Artwork hanging on plasterboard wall in Menton by Handyman In Melbourne."
    },
    
    "/static/images/tv-mounting-wall-art/prahran-picture-hanging-01.webp": {
        "caption": "Picture Hanging",
        "location": "Prahran",
        "alt": "Professional art and heavy picture hanging in a Prahran home by Handyman In Melbourne."
    },

    "/static/images/tv-mounting-wall-art/truganina-tv-wall-mounting-with-concealed-cable-01.webp": {
        "caption": "TV Mounting",
        "location": "Truganina",
        "alt": "Secure TV and floating entertainment unit mounting with concealed cables in Truganina by Handyman In Melbourne."
    },
}